<app-layout>
  <app-voltar route="listagem/cavalo" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>
  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          type="text"
          label="Placa do Cavalo"
          name="TX_PLCA_CAVA"
          formControlName="TX_PLCA_CAVA"
          placeholder="Digite aqui"
          mask="AAA-0000||AAA-0A00"
          [requiredInput]="true"></app-input>

        <app-input
          type="select"
          label="Marca"
          name="TX_MDLO_CAVA"
          formControlName="TX_MDLO_CAVA"
          placeholder="Selecione"
          [requiredInput]="true"
          [selectData]="tipoMarcaOptions"
          (ngModelChange)="escolherTipoCarga($event)">
        </app-input>

        <app-input
          type="select"
          label="Cor"
          name="TX_COR_CAVA"
          formControlName="TX_COR_CAVA"
          placeholder="Selecione"
          [requiredInput]="true"
          [selectData]="tipoCorOptions"
          (ngModelChange)="escolherTipoCor($event)">
          ></app-input
        >

        <app-input
          label="Ano"
          name="NU_ANO_CAVA"
          maxLength="4"
          formControlName="NU_ANO_CAVA"
          mask="0000"
          placeholder="Digite aqui"
          [requiredInput]="true"></app-input>
      </div>
      <app-botao
        *ngIf="!disabledCavalo"
        type="cadastro"
        [text]="isEditing ? 'Editar Cavalo' : 'Cadastrar Cavalo'"
        class="botao-cadastro"
        (click)="postarDados()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
